import { get, isNull } from "lodash";
import React, { Component } from "react";
import { Button, Image, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { bindActionCreators } from "redux";
import { resetSearchInputData } from "../../../actions/common.action";
import {
  clearGroupsListDownloadAction,
  deleteGroupAction,
  getDownloadGroupsListAction,
  getGroupListFilter,
  getGroupsListAction,
  isManagementModeRuning
} from "../../../actions/userManagement.action";
import EditImage from "../../../assets/edit-image.svg";
import ViewOnlyIcon from "../../../assets/view-icon.svg";
import hierarchy_action_icon from "../../../assets/hierarchy_action_icon.svg";
import DisplayByPermission from "../../../component/DisplayByPermission";
import { LoaderPage } from "../../../component/Loader";
import { PopUpModel } from "../../../component/PopUp";
import { STATUS } from "../../../constant";
import {
  getLocalstorage,
  isValidArray,
  removeItemFromLocalStorage
} from "../../../helper";
import PermissionHOC from "../../PermissionHOC";
import {
  DownloadExcelReport,
  Search,
  TableTemplate
} from "../../reusableComponent";
import { PAGE_COUNT } from "../helper";
import { groupListHeadersOptions } from "../usermangement.constant";
import CreateGroup from "./createGroup.Form";
import PeopleGroup from "../../../assets/add-group-icon.png";
import Pagination from "../../Pagination";
import { successToastStyle, errorToastStyle } from "../../../customToast";
import OrganizationalChart from "./OrganizationalChart";
import request from "../../../services/requestService";
import { getGroupHierarchy } from "../../../services/apiServices";
import ZoomLevelProvider from "../../projectList/ZoomLevelProvider";

const Params = {
  limit: 10,
  offset: 0,
  search: "",
  parentId: ""
};

class CreateGroupListing extends Component {
  constructor(props) {
    super(props);
    this.groupModalRef = React.createRef(); // Create a ref for the modal
    this.state = {
      offset: 0,
      filteredArray: [],
      noFilterData: false,
      searchInputData: "",
      isEdit: false,
      paginationoffset: 0,
      groupListParams: { ...Params },
      showBubbleFilter: false,
      selectedFilter: null,
      makeSelectedNull: false,
      isModalDisplay: false,
      parentsLevels: [],
      loaderDisplay: false,
      zoomPercentage: null
    };
  }

  componentDidMount() {
    const { getGroupsListDispatch, getGroupListFilter } = this.props;
    const { groupListParams } = this.state;
    const editKey = getLocalstorage("editkey");
    editKey && this.isIndexingRuningAtBackend(editKey);
    getGroupsListDispatch(groupListParams);
    getGroupListFilter(undefined);
  }
  handleZoomChange = zoom => {
    this.setState({ zoomPercentage: zoom });
  };

  className = zoomPercentage => {
    if (zoomPercentage == 110) {
      return "group-action-cell-110";
    } else if (zoomPercentage == 100) {
      return "group-action-cell";
    } else if (zoomPercentage == 90) {
      return "group-action-cell-90";
    } else if (zoomPercentage == 80) {
      return "group-action-cell-80";
    }
  };

  onToggleModal = value => {
    this.setState(prevState => ({
      displayModal: !prevState.displayModal,
      isEditGroup: true
    }));
  };

  handleClose = () => {
    this.setState(prevState => ({
      isModalDisplay: !prevState.isModalDisplay
    }));
  };

  handleOpen = async value => {
    this.setState({ loaderDisplay: true });
    const response = await request(getGroupHierarchy(value));
    if (response.status) {
      this.setState(prevState => ({
        isModalDisplay: !prevState.isModalDisplay,
        parentsLevels: response.data.data,
        loaderDisplay: false
      }));
    }
  };
  onEdit = value => {
    const editKey = getLocalstorage("editkey");
    if (editKey && Object.values(editKey)[0] !== null) {
      this.setState(
        {
          groupData: value
        },
        () => {
          this.isIndexingRuningAtBackend(editKey);
        }
      );
    } else {
      removeItemFromLocalStorage("editkey");
      this.setState(prevState => ({
        isEdit: !prevState.isEdit,
        groupData: value
      }));
    }
  };

  onDeleteAlertToggle = value => {
    const displayDeleteAlert = this.state.displayDeleteAlert;
    this.setState({
      displayDeleteAlert: !displayDeleteAlert,
      deleteData: (!displayDeleteAlert && value) || null
    });
  };

  onDelete = async value => {
    const { deleteGroupDispatch, getGroupsListDispatch } = this.props;
    const { deleteData } = this.state;
    const response = await deleteGroupDispatch(undefined, {
      groupID: get(deleteData, "id", -1)
    });
    if (response) {
      const { status, message } = response;
      (status &&
        toast.success(
          <p className="toast-text-alignment">{message}</p>,
          successToastStyle
        )) ||
        toast.error(
          <p className="toast-text-alignment">{message}</p>,
          errorToastStyle
        );
      status && getGroupsListDispatch(undefined);
    } else {
      toast.error(
        <p className="toast-text-alignment">Some issues happen</p>,
        errorToastStyle
      );
    }
  };

  getFilterId = (id, elem) => {
    const { getGroupsListDispatch } = this.props;

    if (id === 0) {
      this.removeFilter();
    } else {
      this.setState(
        prevState => ({
          paginationoffset: 0,
          showBubbleFilter: true,
          selectedFilter: elem,
          makeSelectedNull: false,
          groupListParams: {
            ...prevState.groupListParams,
            offset: 0,
            parentId: id
          }
        }),
        () => {
          getGroupsListDispatch(this.state.groupListParams);
        }
      );
    }
  };

  removeFilter = () => {
    const { getGroupsListDispatch } = this.props;
    this.setState(
      prevState => ({
        paginationoffset: 0,
        showBubbleFilter: false,
        selectedFilter: null,
        makeSelectedNull: true,
        groupListParams: {
          ...prevState.groupListParams,
          offset: 0,
          parentId: ""
        }
      }),
      () => {
        getGroupsListDispatch(this.state.groupListParams);
      }
    );
  };

  onPageChange = page => {
    const { getGroupsListDispatch } = this.props;
    this.setState(
      prevState => ({
        paginationoffset: page.selected || 0,
        groupListParams: {
          ...prevState.groupListParams,
          offset: page.selected || 0,
          limit: PAGE_COUNT
        }
      }),
      () => {
        getGroupsListDispatch(this.state.groupListParams);
      }
    );
  };

  callApiOnSuccess = () => {
    const { getGroupsListDispatch } = this.props;
    getGroupsListDispatch(this.state.groupListParams);
  };

  onSearch = (e, values) => {
    const { name, value } = values;
    this.setState(prevState => ({
      paginationoffset: 0,
      groupListParams: {
        ...prevState.groupListParams,
        offset: 0,
        [name]: value
      }
    }));
  };

  callAfterDebounce = () => {
    const { getGroupsListDispatch } = this.props;
    this.setState(
      {
        isSearching: true
      },
      async () => {
        await getGroupsListDispatch(this.state.groupListParams);
        this.setState({
          isSearching: false
        });
      }
    );
  };

  //
  isIndexingRuningAtBackend = async data => {
    const value = Object.values(data)[0];
    if (!isNull(value)) {
      const response = await isManagementModeRuning(undefined, { key: value });
      if (response) {
        const { status, data } = response;
        if (data) {
          removeItemFromLocalStorage("editkey");
          this.setState(prevState => ({
            displayWorkInProgressPopUp: false,
            isEdit: !prevState.isEdit
          }));
        } else {
          this.setState({
            displayWorkInProgressPopUp: true
          });
        }
      }
    }
  };

  onToggleReindexingPopUp = () => {
    this.setState(prevState => ({
      deleteData: !prevState.displayWorkInProgressPopUp
    }));
  };

  componentWillUnmount() {
    const { resetSearchInputData } = this.props;
    resetSearchInputData();
  }

  onGroupsListDownload = async () => {
    const { groupListParams } = this.state;
    const { getDownloadGroupsListAction } = this.props;
    await getDownloadGroupsListAction(undefined, groupListParams);
  };

  onClearDownload = () => {
    const { clearGroupsListDownloadAction } = this.props;
    clearGroupsListDownloadAction();
  };

  render() {
    const { onClearDownload, onGroupsListDownload } = this;
    const {
      groupsList,
      groupListFilter,
      isApiLoading,
      searchInput,
      permission,
      groupsListDownload
    } = this.props;
    const {
      displayModal,
      isEdit,
      groupData,
      displayDeleteAlert,
      offset,
      paginationoffset,
      filteredArray,
      isFilterApplied,
      displayWorkInProgressPopUp,
      groupListParams,
      isSearching,
      makeSelectedNull,
      showBubbleFilter,
      selectedFilter,
      isEditGroup,
      isModalDisplay,
      loaderDisplay,
      parentsLevels,
      zoomPercentage
    } = this.state;
    let pageCount = null;
    let totalItem = null;

    let groupFilteredArray = [];
    let offsetIndex = (offset && offset + 1) || 1;
    let startIndex = offsetIndex * PAGE_COUNT - PAGE_COUNT + 1;

    if (isValidArray(get(groupsList, "groupGroupRolesDTOS"))) {
      const listData = groupsList.groupGroupRolesDTOS;
      let groupList = isFilterApplied ? filteredArray : listData;
      if (searchInput) {
        groupList = [];
        listData.forEach(group => {
          if (group.name.toLowerCase().includes(searchInput.toLowerCase())) {
            groupList.push(group);
          }
        });
      }
      totalItem = groupList.length;
      pageCount = Math.ceil(totalItem / PAGE_COUNT);
      groupFilteredArray = groupList.filter((value, index) => {
        return index + 1 >= startIndex && index + 1 < startIndex + PAGE_COUNT;
      });
    }
    //Filter list based on category
    let filterList = [{ id: 0, name: "Reset All" }];
    if (isValidArray(get(groupListFilter, "data"))) {
      groupListFilter.data.forEach(elem => {
        const currentCategory = elem["category"];
        if (
          currentCategory === "CENTRAL" ||
          currentCategory === "STATE" ||
          currentCategory === "PMG"
        ) {
          filterList.push(elem);
        }
      });
    }
    return (
      <div className="group-management group-listing">
        <div className="header">
          <h3>
            Group{" "}
            {(get(groupsList, "total") && (
              <span>({get(groupsList, "total")})</span>
            )) ||
              null}
          </h3>
          <div className="header-buttons d-flex flex-row">
            <div className="issue-list-exposed-filters pb-2 pr-4">
              <div className="issue-list-filter-right">
                <div className="filters-sections">
                  <Search
                    placeholder="Search"
                    keyName="search"
                    onChange={this.onSearch}
                    value={groupListParams.search}
                    isLoading={isSearching}
                    isSearchingUsers={true}
                    callAfterDebounce={this.callAfterDebounce}
                    filterList={filterList}
                    getFilterId={this.getFilterId}
                    makeSelectedNull={makeSelectedNull}
                  />
                </div>
              </div>
            </div>
            <DownloadExcelReport
              isLoading={groupsListDownload.isLoading}
              downloadLink={groupsListDownload.downloadingSrc}
              onClearDownload={onClearDownload}
              onStartDownloading={onGroupsListDownload}
            />
            <DisplayByPermission
              display={
                get(permission, "createGroup") &&
                !get(permission, "canViewOnlyProject")
              }
            >
              <OverlayTrigger
                trigger="hover"
                defaultShow={false}
                placement="bottom"
                overlay={
                  <Tooltip
                    id={`tooltip-checking`}
                    className="create_project_tolltip"
                  >
                    Create Group
                  </Tooltip>
                }
              >
                <Button
                  className="btn-orange create-btn people-group-btn"
                  size="sm"
                  onClick={this.onToggleModal}
                >
                  <div>
                    <Image src={PeopleGroup} className="peopleGroup" />
                  </div>
                </Button>
              </OverlayTrigger>
            </DisplayByPermission>
          </div>
        </div>
        {/*  Edit Modal Start **/}
        <Modal
          size="lg"
          show={isEdit}
          onHide={this.onEdit}
          aria-labelledby="example-modal-sizes-title-lg"
          className="edit-user-modal-form"
        >
          <LoaderPage loading={isApiLoading === STATUS.LOADING} />
          <div className="modal-box-shadow" ref={this.groupModalRef}>
            <Modal.Header closeButton className="header-modal">
              <Modal.Title id="example-modal-sizes-title-lg">
                {!get(permission, "canViewOnlyProject")
                  ? "Edit Group"
                  : "View Group"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="body-modal create-group create-group-modal">
              <CreateGroup
                togglePopUp={this.onEdit}
                isEdit={isEdit}
                groupData={groupData}
                isEditGroup={isEditGroup}
                callApiOnSuccess={this.callApiOnSuccess}
                groupModalRef={this.groupModalRef}
              />
            </Modal.Body>
          </div>
        </Modal>
        {/*  Edit Modal End **/}

        {/*  Create Modal **/}
        <Modal
          size="lg"
          show={displayModal}
          onHide={this.onToggleModal}
          aria-labelledby="example-modal-sizes-title-lg"
          className="create-user-form"
        >
          <LoaderPage
            loading={isApiLoading === STATUS.LOADING || loaderDisplay}
          />
          <div className="modal-box-shadow" ref={this.groupModalRef}>
            <Modal.Header closeButton className="header-modal">
              <Modal.Title id="example-modal-sizes-title-lg">
                Create Group
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="body-modal create-group">
              <CreateGroup
                togglePopUp={this.onToggleModal}
                callApiOnSuccess={this.callApiOnSuccess}
                groupModalRef={this.groupModalRef}
              />
            </Modal.Body>
          </div>
        </Modal>

        {/*  Create Modal End **/}

        {/*  Hierarchy Modal **/}
        <LoaderPage loading={loaderDisplay} />
        {isModalDisplay && !loaderDisplay ? (
          <OrganizationalChart
            isModalDisplay={isModalDisplay}
            parentsLevels={parentsLevels}
            onClick={this.handleClose}
          />
        ) : null}

        {/*  Hierarchy End **/}

        {/*  Delete Alert Pop Up **/}

        <PopUpModel
          open={displayDeleteAlert}
          text={"Are you sure you want to delete it?"}
          leftBtnText={"Yes"}
          rightBtnText={"No"}
          onCancel={this.onDeleteAlertToggle}
          onSubmit={this.onDelete}
        />

        <PopUpModel
          open={displayWorkInProgressPopUp}
          text={"Some Process is runing in backend. Please wait."}
          rightBtnText={"Close"}
          onCancel={this.onToggleReindexingPopUp}
        />
        {showBubbleFilter ? (
          <div className="applied-filter-list pt-1 mb-0">
            <div className="applied-filter mb-0">
              {selectedFilter && selectedFilter.name}
              <span
                className="close"
                onClick={e => {
                  this.removeFilter();
                }}
              >
                X
              </span>
            </div>
          </div>
        ) : null}
        <TableTemplate
          isGroupTable={true}
          isUsersTable={true}
          isLoading={isApiLoading === STATUS.LOADING}
          headersOptions={groupListHeadersOptions}
          bodyOptions={groupFilteredArray}
          bodyTemplate={(options, index) => (
            <>
              <td>
                {index + 1 + groupListParams.offset * groupListParams.limit}
              </td>
              <td>{options.name}</td>
              <td>{options.parentName}</td>
              {/* <td>
                <OverlayTrigger
                  trigger="hover"
                  defaultShow={false}
                  overlay={
                    <Tooltip
                      id={`tooltip-checking`}
                      className="edit_group_tooltip"
                    >
                      Edit Group
                    </Tooltip>
                  }
                >
                  <Image
                    className={"edit-image"}
                    src={
                      !get(permission, "canViewOnlyProject")
                        ? EditImage
                        : ViewOnlyIcon
                    }
                    onClick={this.onEdit.bind(this, options)}
                  />
                </OverlayTrigger>

                <OverlayTrigger
                  trigger="hover"
                  defaultShow={false}
                  overlay={
                    <Tooltip
                      id={`tooltip-checking`}
                      className="organizational_hierarchy_tooltip"
                    >
                      Organizational Hierarchy
                    </Tooltip>
                  }
                >
                  <Image
                    className={"edit-image"}
                    src={hierarchy_action_icon}
                    onClick={this.handleOpen.bind(this, options.id)}
                    style={{
                      visibility:
                        options.parentName == null || options.name == null
                          ? "hidden"
                          : null,
                      paddingLeft: 8
                    }}
                  />
                </OverlayTrigger>
              </td> */}
              <ZoomLevelProvider onZoomChange={this.handleZoomChange} />
              <td className={this.className(zoomPercentage)}>
                <div className="action-icons">
                  <OverlayTrigger
                    trigger="hover"
                    defaultShow={false}
                    overlay={
                      <Tooltip
                        id="tooltip-edit-group"
                        className="edit_group_tooltip"
                      >
                        Edit Group
                      </Tooltip>
                    }
                  >
                    <Image
                      className="user-edit-image"
                      src={
                        !get(permission, "canViewOnlyProject")
                          ? EditImage
                          : ViewOnlyIcon
                      }
                      onClick={this.onEdit.bind(this, options)}
                    />
                  </OverlayTrigger>

                  <OverlayTrigger
                    trigger="hover"
                    defaultShow={false}
                    overlay={
                      <Tooltip
                        id="tooltip-org-hierarchy"
                        className="organizational_hierarchy_tooltip"
                      >
                        Organizational Hierarchy
                      </Tooltip>
                    }
                  >
                    <Image
                      className="user-edit-image hierarchy-icon"
                      src={hierarchy_action_icon}
                      onClick={this.handleOpen.bind(this, options.id)}
                      style={{
                        visibility:
                          options.parentName == null || options.name == null
                            ? "hidden"
                            : "visible"
                      }}
                    />
                  </OverlayTrigger>
                </div>
              </td>
            </>
          )}
          headersTemplate={options => (
            <>
              <th>{options.title}</th>
            </>
          )}
        />
        {isApiLoading === STATUS.SUCCESS ? (
          <div className="pagination-wrapper">
            <div className="pagination pagination-in-user-listing">
              <Pagination
                offset={paginationoffset}
                pageCount={get(groupsList, "total") / PAGE_COUNT}
                onPageChange={this.onPageChange}
              />
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    groupsList: state.userManagementReducer.groupsList.data,
    groupListFilter: state.userManagementReducer.groupListFilter,
    isApiLoading: state.userManagementReducer.isGroupListLoading,
    searchInput: state.commonReducer.searchInput,
    isGroupListLoading: state.userManagementReducer.isGroupListLoading,
    groupsListDownload: state.userManagementReducer.groupsListDownload,
    headingDetailsData: state.pmgReducer.headingDetailsData
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getGroupsListDispatch: getGroupsListAction,
      getGroupListFilter: getGroupListFilter,
      deleteGroupDispatch: deleteGroupAction,
      resetSearchInputData: resetSearchInputData,
      getDownloadGroupsListAction,
      clearGroupsListDownloadAction
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PermissionHOC(CreateGroupListing));
